import { ListChart, ListChartProps } from '../../../../renderers/list-chart/list-chart.component';
import { PUDO_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_DEFINITION } from './pudo-transaction-volume-by-state-list-chart.definition';
import { PUDO_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_MOCK_DATA } from './pudo-transaction-volume-by-state-list-chart.mock';

export const PudoTransactionVolumeByStateListChart = (props: ListChartProps) => <ListChart {...props} />;

PudoTransactionVolumeByStateListChart.definition = PUDO_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_DEFINITION;
PudoTransactionVolumeByStateListChart.mockData = PUDO_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_MOCK_DATA;
